import styled, { css } from 'styled-components';
import { colours, common } from 'themes/default';
import Button from 'components/ui/Button';

const {
  buttons: {
    tertiary: { activeBackgroundColour, activeBorderColour, activeFontColour }
  }
} = common;

const activeButtonStyle = css`
  background-color: ${activeBackgroundColour || colours.Shades.BlueShade40};
  border-color: ${activeBorderColour || colours.Shades.BlueShade40};

  button,
  a,
  div {
    color: ${activeFontColour || colours.Greyscale.White};
  }
`;

// This has been added to override the focus and active styles
// that have now been introduced to buttons to support the rebrand
const selectedPassengerButtonStyle = css`
  ${activeButtonStyle}

  &:focus-visible {
    ${activeButtonStyle}
  }

  &:active {
    ${activeButtonStyle}
  }
`;

export const PassengerButton = styled(Button)`
  margin: 0;
  height: 24px;

  div {
    line-height: 24px;
  }

  ${(props) => (props.selected ? selectedPassengerButtonStyle : '')}
`;
